<template>
  <div>
    <!-- LIST -->
    <div v-for="(entry, index)  in sorted" :key="entry.ceid">
      <div v-if="entry.name">
        <h3>
          <span class="title">{{index+1}}. {{entry.total}} {{entry.entry.title | capitalize}}</span> by
          <span class="photographer">{{entry.name.toLowerCase() }}</span>
        </h3>
        <h2>{{entry.uid}}</h2>
        <div class="d-flex">
          <div class="flex-grow-1">
            <review-entry-meta :entry="entry"/>
          </div>
          <div class="p-2 text-nowrap review-controls"></div>
        </div>

        <review-gallery-strip :photos="entry.entry.photos"/>

        <div class="shortlist-scores">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Total</th>
                <th>aesthetic</th>
                <th>originality</th>
                <th>resonance</th>
                <th>technical</th>
                <th>Viewed</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(score, key) in entry.scores" :key="key">
                <td>{{score.name[0]}} {{score.name[1]}}</td>
                <td>{{score.total != -1 ? score.total : '-'}}</td>
                <td>{{score.score.aesthetic != -1 ? score.score.aesthetic : '-' }}</td>
                <td>{{score.score.originality != -1 ? score.score.originality : '-' }}</td>
                <td>{{score.score.resonance != -1 ? score.score.resonance : '-' }}</td>
                <td>{{score.score.technical != -1 ? score.score.technical : '-' }}</td>
                <td>{{score.viewed}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- entrant in entrants -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ReviewGalleryStrip from '@/components/review/ReviewGalleryStrip.vue'
import ReviewEntryMeta from '@/components/review/ReviewEntryMeta.vue'
export default {
  components: { ReviewGalleryStrip, ReviewEntryMeta },
  computed: {
    ...mapState({
      entries: state => state.shortlist.entries,
      isAdmin: state => state.judging.admin
    }),
    ...mapGetters({
      sorted: 'shortlist/orderedEntries'
    })
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString().toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>

<style scoped>
</style>
